import { yup } from '@framework/validation';
import { RuleType } from '../../IRule';
import { IRuleType } from '../../IRuleType';
import { NeedSignRuleComponent } from './NeedSignRuleComponent';

const configValidator = yup
  .object({
    value: yup.boolean().notRequired().label('Richiede Firma'),
    customMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown()
  .nullable();

export const NeedSignRule: IRuleType<yup.InferType<typeof configValidator>> = {
  type: RuleType.NeedSign,
  name: 'Richiede firma',
  configComponent: NeedSignRuleComponent,
  configValidator: configValidator,
  validator: schema => schema,
};
